import * as React from 'react';
import AmondzLogo from './AmondzLogo';
import Img from '../../Img';
import SearchIcon from '../../../static/images/home/header_search_black_btn.svg';
import CartIcon from '../../../static/images/home/header_cart_btn.svg';
import LikeIcon from './LinkIcon';
import { IconList, PageHeaderStyle } from './style';

const PageHeader = (): JSX.Element => {
  return (
    <PageHeaderStyle>
      <AmondzLogo width={97} height={20} />
      <IconList>
        <Img src={SearchIcon} />
        <LikeIcon width={30} height={30} />
        <Img src={CartIcon} />
      </IconList>
    </PageHeaderStyle>
  );
};

export default PageHeader;
